/**
 * MOVE SIZES — the one list every move-size picker reads (the lead file header,
 * shown on the Estimate tab, and the New Lead pop-up).
 *
 * `leads.move_size` is free text, so a value not on this list (an older lead, a
 * provider's own wording) is shown as an extra option where it is set rather
 * than dropped.
 *
 * Intake sets only labels on this list: backend/src/lib/intake/moveSizes.ts is
 * its copy (the backend build cannot import from here) — change both together.
 */
export const MOVE_SIZES = [
  'Studio Apartment',
  '1 Bedroom Apartment',
  '1 Bedroom Home',
  '2 Bedroom Apartment',
  '2 Bedroom Home',
  '3 Bedroom Apartment',
  '3 Bedroom Home',
  '4 Bedroom Home',
  '5 Bedroom Home',
  'Storage Unit (Small)',
  'Storage Unit (Large)',
  'Office / Commercial',
];
